export class ImagePackage {
  imagePackageId?: number;
  patientId: string;
  visitId: string;
  studyId?: string;
  status: ImagePackageStatus;
  diagnosisOverride?: boolean;
  diagnosisOverrideComment?: string;
  fp: number;
  faf: number;
  oct: number;
  fa: number;
  octType?: string;
}

export enum ImagePackageStatus {
  uploading = 'uploading',
  diagnosing = 'diagnosing',
  grading = 'grading',
  submitted = 'submitted',
  locked = 'locked',
  notGrading = 'not grading'
}

export class ImagePackageComments {
  imageComments: string[];
  packageUploadComment: string;
}


// WEBPACK FOOTER //
// ./src/app/models/image-package.model.ts